(function(){
  function init(){
    var root=document.querySelector('[data-fl-notes]');
    if(!root || root.dataset.initialized)return;
    root.dataset.initialized='true';
    var trigger=root.querySelector('[data-fl-notes-trigger]');
    var panel=root.querySelector('[data-fl-notes-panel]');
    var close=root.querySelector('[data-fl-notes-close]');
    var success=root.querySelector('[data-fl-notes-success]');
    var error=root.querySelector('[data-fl-notes-error]');
    var storageKey='floralia_notes_dismissed_until';
    var previousFocus=null;
    function dismissed(){try{return Number(localStorage.getItem(storageKey)||'0')>Date.now()}catch(e){return false}}
    function markDismissed(){try{localStorage.setItem(storageKey,String(Date.now()+1000*60*60*24*14))}catch(e){}}
    function showTrigger(){if(!dismissed() && !success && root.dataset.signupState!=='subscribed')trigger.hidden=false}
    function open(){previousFocus=document.activeElement;panel.hidden=false;trigger.hidden=true;trigger.setAttribute('aria-expanded','true');(panel.querySelector('input[type=email]')||close).focus()}
    function shut(){panel.hidden=true;trigger.setAttribute('aria-expanded','false');markDismissed();trigger.hidden=true;if(previousFocus&&previousFocus.focus)previousFocus.focus()}
    trigger.addEventListener('click',open);
    document.addEventListener('click',function(event){
      var opener=event.target.closest&&event.target.closest('[data-fl-notes-reopen]');
      if(opener){event.preventDefault();open()}
    });
    close.addEventListener('click',shut);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!panel.hidden)shut()});
    var copy=root.querySelector('[data-fl-notes-copy]');
    if(copy)copy.addEventListener('click',function(){var code='FLORALIAFIRST50';if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(code).then(function(){copy.textContent='Copied ✓'}).catch(function(){copy.textContent=code})}else{copy.textContent=code}});
    var directSignup=false;
    try{directSignup=(new URLSearchParams(window.location.search)).get('floralia_notes')==='1'}catch(e){}
    if(success||error||directSignup){open();if(success)markDismissed()}else{setTimeout(showTrigger,8000)}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();